import React from 'react';

// Bootstrap (nền tảng UI giống lmsapp-service) + Remix Icon (dùng bởi 2 trang clone)
import 'bootstrap/dist/css/bootstrap.min.css';
import 'remixicon/fonts/remixicon.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

import Route from './Routes';

function App() {
  return (
    <React.Fragment>
      <ToastContainer style={{ zIndex: 10000 }} />
      <Route />
    </React.Fragment>
  );
}

export default App;
